import { initializeScrollAnimations } from './gsap-animation.js';
import { closeModal } from './scripts.js';
import { swiperTeam, initializeSwiper } from './swiper.js';

export function ajaxCalls() {
    const body = document.body;
    const teamAjaxButton = document.getElementById("teamAjaxButton");
    const sectionTeamAjax = document.querySelector('.section-team__ajax');
    const swiperButtonNext = document.querySelector('.section-team .swiper-button-next');
    const swiperButtonPrev = document.querySelector('.section-team .swiper-button-prev');
    const sectionTeam = document.querySelector('.section-team');

    /* Single person ajax call */

    const teamContainer = document.querySelector('.section-team');
    const singlePerson = document.getElementById('team2');

    if (teamContainer) {
        teamContainer.addEventListener('click', handleItemClick);
    }

    function handleItemClick(event) {
        const target = event.target.closest('.section-team__element');
        if (target) {
            body.classList.add('is-overflow');
            body.classList.add('is-overlay');
            const post_id = target.getAttribute('data-id');

            var xhr = new XMLHttpRequest();
            xhr.open('POST', myAjax.ajaxurl, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var response = JSON.parse(xhr.responseText);
                    singlePerson.innerHTML = response.data.html_data;

                    setTimeout(function () {
                        singlePerson.querySelector('.team-single').classList.add('active');
                    }, 500);

                    const closeButton = singlePerson.querySelector('.close');
                    if (closeButton) {
                        closeButton.addEventListener('click', handleCloseButtonClick);
                    }

                }
            };

            var data = {
                action: 'person',
                post_id: post_id
            };

            var encodedData = [];

            for (var key in data) {
                encodedData.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
            }

            encodedData = encodedData.join('&');

            xhr.send(encodedData);
        }
    }

    function handleCloseButtonClick(event) {
        closeModal();
    }

    /* Realization ajax call */

    const realizationInputs = document.querySelectorAll('.section-realization__filters input');
    const realizationAjaxResponse = document.querySelector('.realization-ajax');
    const meetUs = myAjax.meetUs;
    const collapse = myAjax.collapse;


    realizationInputs.forEach((realizationInput) => {
        realizationInput.addEventListener('change', ajaxRealization);
    });

    function ajaxRealization(event) {
        const val = event.target.value;

        var xhr = new XMLHttpRequest();
        xhr.open('POST', myAjax.ajaxurl, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                var response = JSON.parse(xhr.responseText);
                realizationAjaxResponse.innerHTML = response.data.html_data;
            }
        };

        var data = {
            action: 'realizationAjax',
            val: val
        };

        var encodedData = [];

        for (var key in data) {
            encodedData.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
        }

        encodedData = encodedData.join('&');

        xhr.send(encodedData);
    }


    let type = 'grid';

    if (teamAjaxButton) {

        teamAjaxButton.addEventListener('click', function () {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', myAjax.ajaxurl, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var response = JSON.parse(xhr.responseText);
                    sectionTeamAjax.innerHTML = response.data.html_data;

                    if (teamAjaxButton.classList.contains('grid-layout')) {
                        type = 'swiper';
                        teamAjaxButton.textContent = collapse;
                        swiperButtonNext.style.display = 'none';
                        swiperButtonPrev.style.display = 'none';
                        teamAjaxButton.classList.remove('grid-layout');
                        teamAjaxButton.classList.add('swiper-layout');
                        initializeScrollAnimations();
                    } else {
                        type = 'grid';
                        teamAjaxButton.textContent = meetUs;
                        swiperButtonNext.style.display = 'flex';
                        swiperButtonPrev.style.display = 'flex';
                        teamAjaxButton.classList.remove('swiper-layout');
                        teamAjaxButton.classList.add('grid-layout');

                        initializeSwiper();
                        initializeScrollAnimations();
                    }


                    if (sectionTeam) {
                        setTimeout(() => {
                            sectionTeam.scrollIntoView({
                                behavior: 'instant',
                                block: 'start'
                            });
                        }, 250);
                    }




                }
            };

            var data = {
                action: 'team',
                type: type,
            };

            var encodedData = [];

            for (var key in data) {
                encodedData.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
            }

            encodedData = encodedData.join('&');

            xhr.send(encodedData);
        });
    }

};